/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const visitClinicalExtractions = sqliteTable('visit_clinical_extractions', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  patient_id: text('patient_id'),
  visit_id: text('visit_id'),
  encounter_id: text('encounter_id'),
  appointment_id: text('appointment_id'),
  conversation_id: text('conversation_id'),
  section_key: text('section_key'),
  source_recording_id: text('source_recording_id'),
  source_transcript: text('source_transcript'),
  source_transcript_hash: text('source_transcript_hash'),
  provider: text('provider'),
  provider_endpoint: text('provider_endpoint'),
  model_version: text('model_version'),
  summary: text('summary'),
  symptoms_json: text('symptoms_json'),
  diagnoses_json: text('diagnoses_json'),
  allergies_json: text('allergies_json'),
  status: text('status'),
  error_code: text('error_code'),
  error_message: text('error_message'),
  attempt_count: integer('attempt_count'),
  requested_at: text('requested_at'),
  completed_at: text('completed_at'),
  created_by: text('created_by'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});
